<template>
  <div>
    <label class="typo__label">{{ label }}</label>
    <multiselect
      :value="value"
      tag-placeholder="เพิ่มในรายการใหม่"
      placeholder="ค้นหาหรือเพิ่ม"
      label="value"
      track-by="value"
      :options="options"
      :multiple="true"
      :taggable="true"
      @tag="addTag"
      @select="selectValue"
      @remove="removeValue"
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  name: 'multi-select-tag',
  props: {
    label: {
      default: null,
      required: true
    },
    value: {
      default: function () {
        return []
      },
      required: true,
    },
    options: {
      default: function () {
        return []
      },
      required: false,
    }
  },
  methods: {
    addTag (newTag) {
      const tag = {
        value: newTag,
      }
      this.options.push(tag)
      this.value.push(tag)
    },
    selectValue (value) {
      this.value.push(value)
    },
    removeValue (removeItem) {
      this.value.splice(this.value.indexOf(removeItem), 1)
    }
  }
}
</script>